import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RolloffBucket, TeamRolloffData, TeamRolloffRow } from '../../../interfaces/metrics';

@Component({
  selector: 'bst-horizon-rail',
  templateUrl: './horizon-rail.component.html',
  styleUrls: ['./horizon-rail.component.scss'],
  standalone: false,
})
export class HorizonRailComponent {
  @Input() data!: TeamRolloffData;
  @Output() bucketSelected = new EventEmitter<{ start: string; rows: TeamRolloffRow[] }>();

  start(b: RolloffBucket): string { return b.weekStart ?? b.monthStart ?? ''; }

  // Rows whose freeFrom falls inside this bucket (week = 7 days, month = calendar month).
  rowsFor(b: RolloffBucket): TeamRolloffRow[] {
    const s = this.start(b);
    if (b.weekStart) {
      const end = new Date(s + 'T00:00:00Z'); end.setUTCDate(end.getUTCDate() + 7);
      const endStr = end.toISOString().slice(0, 10);
      return this.data.rows.filter(r => r.freeFrom >= s && r.freeFrom < endStr);
    }
    return this.data.rows.filter(r => r.freeFrom.slice(0, 7) === s.slice(0, 7));
  }

  pick(b: RolloffBucket): void {
    if (b.comingFree > 0) { this.bucketSelected.emit({ start: this.start(b), rows: this.rowsFor(b) }); }
  }

  kEuro(v: number | undefined): string {
    if (!v) { return ''; }
    return v >= 1000 ? '€' + Math.round(v / 1000) + 'k' : '€' + v;
  }

  // monthLabel is gone: the template formats the month with the date pipe, which is
  // locale-aware, where this returned a bare '08' that read as a day of the month next
  // to the day/month labels on the weekly cells.
  weekDay(s: string): string { return s.slice(8, 10) + '/' + s.slice(5, 7); }

  hasEvents(): boolean { return this.data.rows.length > 0; }
}
